import React, { useState, useEffect } from "react";
import { useRouter } from "next/router";
import { campaign_item_data } from "../../data/campaign_data";
import Auctions_dropdown from "../../components/dropdown/Auctions_dropdown";
import Social_dropdown from "../../components/dropdown/Social_dropdown";
import Collection_items from "../../components/collectrions/Collection_items";
import Image from "next/image";
import Link from "next/link";
import Meta from "../../components/Meta";
import { brand_detail_page, cause_detail_page } from "../../services/landing";
import ProSaleBanner from "../../components/ico-landing/ProSaleBanner";
import Cta from "../../components/cta/cta";
import { useDispatch, useSelector } from "react-redux";
import { setItemsTabIndex } from "../../redux/counterSlice";
import Brand_items from "../../components/brand/Brands_items";
export const baseURL = `${process.env.BASE_URL}/`;

const CausePage = () => {
  const [likesImage, setLikesImage] = useState(false);
  const [campaign, setCampaign] = useState({});
  const [data, setData] = useState([]);
  const [campaignDes, setCampaignDes] = useState(false);
  const [loading, setLoading] = useState(false);
  const router = useRouter();
  const { causeId } = router.query;

  const dispatch = useDispatch();

  // Dispatch the action to update itemsTabIndex
  const handleClick = () => {
    dispatch(setItemsTabIndex(3));
    // setCampaignDes(true);
  };

  useEffect(() => {
    const fetchApi = (myCampaignId) => {
      // getDetails
      if (myCampaignId !== undefined) {
        cause_detail_page(myCampaignId)
          .then((res) => {
            // debugger
            let tempArray = [];
            // const inputString = res?.causeDetails.overview.description;
            // Split the string into an array of sentences using the period as the delimiter
            // const sentencesArray = inputString.split(".");
            // const firstSentence = sentencesArray[0].trim();
            setCampaign(res.causeDetails);

            // const dateString = res?.causeDetails.overview.startDate;
            // const endDateString = res?.causeDetails.overview.endDate;

            // const dateObjectStartDate = new Date(dateString);
            // const dateObjectEndDate = new Date(endDateString);

            // const options = {
            //   year: "numeric",
            //   month: "short",
            //   day: "numeric",
            // };
            // const formattedDateStartDate =
            //   dateObjectStartDate.toLocaleDateString("en-US", options);
            // const formattedDateEndDate = dateObjectEndDate.toLocaleDateString(
            //   "en-US",
            //   options
            // );

            const newObj = {
              success: res?.success || {},
              // username: res?.username || {},
              organization: res?.causeDetails || {},
              // assests: res?.assets || {},
              // shortDescription: firstSentence,

              details: [
                {
                  id: "07.2K",
                  detailsNumber: "Country",
                  detailsText: res?.causeDetails.country,
                },

                {
                  id: "22.55",
                  detailsNumber: "Category",
                  detailsText: res?.causeDetails.category,
                },

                {
                  id: ".2K",
                  detailsNumber: "City",
                  detailsText: res?.causeDetails.city,
                },
                {
                  id: "20K",
                  detailsNumber: "Reg. Number",
                  detailsText: res?.causeDetails.registrationNum,
                },
                {
                  id: "30K",
                  detailsNumber: "Country Reg.",
                  detailsText: res?.causeDetails.countryOfRegistration,
                },
              ],
            };
            tempArray.push(newObj);
            // console.log("This is new Obj", newObj.success.identityVerification);
            setData(tempArray[0]);
            // console.log(tempArray);
            setLoading(true);
            // console.log(newObj);
          })
          .catch((err) => {
            console.log(err);
          });
      }
    };
    if (router.isReady) {
      const { causeId } = router.query;
      if (causeId === undefined) return null;
      fetchApi(causeId);
    }
  }, [router.isReady, router.query]);

  useEffect(() => {
    dispatch(setItemsTabIndex(1));
  }, []);

  const handleLikes = () => {
    if (!likesImage) {
      setLikesImage(true);
    } else {
      setLikesImage(false);
    }
  };

  const handleOwnerNameClick = (type) => {
    if (type === "brand") {
      router.push(`/browse-brands-details/${data.organization._id}`);
    } else if (type === "cause") {
      router.push(`/npos-causes-details/${data.organization._id}`);
    } else {
      router.push(`/influencers-details/${data.organization._id}`);
    }
  };

  return (
    <>
      <Meta title={`${causeId} || Impactoverse | Impact DOT Marketplace`} />

      <div className="pt-[5.5rem] lg:pt-24">
        {data !== null ? (
          <div>
            <div>
              <div className="relative h-[300px]">
                <Image
                  src={baseURL + data.organization?.logoUrl}
                  alt="banner"
                  width={1519}
                  height={300}
                  className="w-full h-full object-center object-cover"
                />
              </div>
              <section className="dark:bg-jacarta-800 bg-light-base relative pb-12 pt-28">
                {/* <!-- Avatar --> */}
                <div className="absolute left-1/2 top-0 z-10 flex -translate-x-1/2 -translate-y-1/2 items-center justify-center">
                  <figure className="relative h-40 w-40 dark:border-jacarta-600 rounded-xl border-[5px] border-white">
                    <Image
                      width={141}
                      height={141}
                      src={baseURL + data.organization?.logoUrl}
                      alt={data.shortDescription}
                      className="dark:border-jacarta-600 rounded-xl border-[5px] border-white object-cover h-40 w-full"
                    />
                    <div
                      className="dark:border-jacarta-600 bg-green absolute -right-3 bottom-0 flex h-6 w-6 items-center justify-center rounded-full border-2 border-white"
                      data-tippy-content="Verified Collection"
                    >
                      {/* {icon && ( */}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        width="24"
                        height="24"
                        className="h-[.875rem] w-[.875rem] fill-white"
                      >
                        <path fill="none" d="M0 0h24v24H0z"></path>
                        <path d="M10 15.172l9.192-9.193 1.415 1.414L10 18l-6.364-6.364 1.414-1.414z"></path>
                      </svg>
                      {/* )} */}
                    </div>
                  </figure>
                </div>

                <div className="container">
                  <div className="text-center">
                    <h2 className="font-display text-jacarta-700 mb-2 text-4xl font-medium dark:text-white">
                      {data.organization?.name}
                    </h2>

                    <div className="dark:bg-jacarta-800 dark:border-jacarta-600 border-jacarta-100 mb-8 inline-flex flex-wrap items-center justify-center rounded-xl border bg-white">
                      {data.details?.map(
                        ({ id, detailsNumber, detailsText }) => {
                          return (
                            <Link
                              href="#"
                              key={id}
                              className="dark:border-jacarta-600 border-jacarta-100 w-1/2 rounded-l-xl border-l py-4 hover:shadow-md sm:w-32"
                            >
                              <div className="text-jacarta-700 mb-1 text-base font-bold dark:text-white uppercase">
                                {detailsNumber}
                              </div>
                              <div className="text-2xs dark:text-jacarta-400 font-medium tracking-tight">
                                {detailsText}
                              </div>
                            </Link>
                          );
                        }
                      )}
                    </div>

                    <p className="dark:text-jacarta-300 text-lg">
                      {data.organization?.about}
                    </p>

                    {/* Comment this as did not know how it is doing  */}
                    <div className="mt-6 flex items-center justify-center space-x-2.5 relative">
                      <div className="dark:border-jacarta-600 dark:hover:bg-jacarta-600 border-jacarta-100 hover:bg-jacarta-100 dark:bg-jacarta-700 rounded-xl border bg-white">
                        {/* <Likes data={} /> */}
                        <div
                          className="js-likes relative inline-flex h-10 w-10 cursor-pointer items-center justify-center text-sm"
                          onClick={() => handleLikes()}
                        >
                          <button>
                            {likesImage ? (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                width={24}
                                height={24}
                                className="h-4 w-4 fill-jacarta-500 dark:fill-jacarta-200"
                              >
                                <path fill="none" d="M0 0H24V24H0z" />
                                <path d="M12.001 4.529c2.349-2.109 5.979-2.039 8.242.228 2.262 2.268 2.34 5.88.236 8.236l-8.48 8.492-8.478-8.492c-2.104-2.356-2.025-5.974.236-8.236 2.265-2.264 5.888-2.34 8.244-.228zm6.826 1.641c-1.5-1.502-3.92-1.563-5.49-.153l-1.335 1.198-1.336-1.197c-1.575-1.412-3.99-1.35-5.494.154-1.49 1.49-1.565 3.875-.192 5.451L12 18.654l7.02-7.03c1.374-1.577 1.299-3.959-.193-5.454z" />
                              </svg>
                            ) : (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                width={24}
                                height={24}
                                className="h-4 w-4 fill-jacarta-500 dark:fill-jacarta-200"
                              >
                                <path fill="none" d="M0 0H24V24H0z" />
                                <path d="M12.001 4.529c2.349-2.109 5.979-2.039 8.242.228 2.262 2.268 2.34 5.88.236 8.236l-8.48 8.492-8.478-8.492c-2.104-2.356-2.025-5.974.236-8.236 2.265-2.264 5.888-2.34 8.244-.228zm6.826 1.641c-1.5-1.502-3.92-1.563-5.49-.153l-1.335 1.198-1.336-1.197c-1.575-1.412-3.99-1.35-5.494.154-1.49 1.49-1.565 3.875-.192 5.451L12 18.654l7.02-7.03c1.374-1.577 1.299-3.959-.193-5.454z" />
                              </svg>
                            )}
                          </button>
                        </div>
                      </div>

                      <Social_dropdown />
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
      {/* <Cta data={data}></Cta> */}
      <section id="section1">
        <Brand_items
          description={""}
          feasibility={""}
          impact={""}
          campaignDes={""}
          isSuperCampaign={""}
          causeId={""}
        />
      </section>
    </>
  );
};

export default CausePage;
